import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const PrivacyPolicy = () => {
  const location = useLocation();
  const baseUrl = 'https://iconvertify.com';
  // CRITICAL FIX: Canonical URL must ALWAYS match the current page URL
  const currentPath = location.pathname;
  const canonicalUrl = `${baseUrl}${currentPath}`;
  const pageTitle = 'Privacy Policy | iconvertify - Free Online File Converter';
  const description = 'Read our privacy policy to understand how iconvertify collects, uses, and protects your personal information when using our free online file conversion tools.';
  const keywords = 'privacy policy, data protection, user privacy, file converter privacy, iconvertify privacy';
  useEffect(() => {
    // Load the privacy policy content from the HTML file
    fetch('/PrivacyPolicyTermly.html')
      .then(response => response.text())
      .then(html => {
        // Extract the body content and inject it into our container
        const container = document.getElementById('privacy-policy-container');
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const content = doc.querySelector('[data-custom-class="body"]');
        if (container && content) {
          container.innerHTML = content.outerHTML;
        }
      });
  }, []);

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords} />
        <link rel="canonical" href={canonicalUrl} />
        <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
        
        {/* OpenGraph */}
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={description} />
        <meta property="og:image" content={`${baseUrl}/favicon-assets/android-chrome-512x512.png`} />
        <meta property="og:image:width" content="512" />
        <meta property="og:image:height" content="512" />
        <meta property="og:image:alt" content="iconvertify - Privacy Policy" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={canonicalUrl} />
        <meta property="og:site_name" content="iconvertify" />
        
        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={pageTitle} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content={`${baseUrl}/favicon-assets/android-chrome-512x512.png`} />
        <meta name="twitter:image:alt" content="iconvertify - Privacy Policy" />
      </Helmet>
      <div className="min-h-screen bg-white">
        <div className="max-w-4xl mx-auto px-4 py-12">
          <h1 className="text-4xl font-bold mb-6">Privacy Policy</h1>
          <div id="privacy-policy-container" className="prose max-w-none">
            {/* Privacy policy content will be injected here */}
          </div>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;
